(() => {
  const controllers = new WeakMap();
  const layouts = ['single', 'stacked', 'drawer'];

  function enhance(header) {
    if (controllers.has(header) || header.classList.contains('drawer-menu')) return;
    const nav = header.querySelector('.header__inline-menu');
    const list = nav?.querySelector(':scope > .list-menu--inline');
    const icons = header.querySelector('.header__icons');
    const drawer = header.querySelector('header-drawer');
    const logo = header.querySelector('.header__heading-logo');
    if (!list || !icons || !drawer) return;

    const section = header.closest('.section-header');
    const originalBreakpoint = drawer.dataset.breakpoint;
    let frame = 0;
    let previousLayout = '';

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    function update() {
      frame = 0;
      if (!header.isConnected) return;
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      header.classList.toggle('pm-header-fit-ready', desktop);
      let layout = '';

      if (desktop && header.clientWidth) {
        const style = getComputedStyle(header);
        const available = header.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const menuWidth = list.scrollWidth;
        const gap = parseFloat(style.columnGap) || 0;
        const isHome = header.classList.contains('pm-site-header--home');
        const logoWidth = logo?.getBoundingClientRect().width || 0;
        const singleWidth = menuWidth + icons.getBoundingClientRect().width + logoWidth + gap * 2;
        layout = singleWidth <= available + 2 ? 'single' : 'drawer';
      }

      if (layout !== previousLayout) {
        const summary = drawer.querySelector(':scope > details > summary');
        const drawerWasFocused = drawer.contains(document.activeElement);
        const navWasFocused = nav.contains(document.activeElement);
        const details = drawer.querySelector(':scope > details');
        if (details?.open && typeof drawer.closeMenuDrawer === 'function') {
          drawer.closeMenuDrawer(null, summary);
          summary?.setAttribute('aria-expanded', 'false');
        }
        header.querySelectorAll('header-menu').forEach((menu) => menu.close?.());
        layouts.forEach((name) => header.classList.toggle(`pm-header-layout-${name}`, layout === name));
        drawer.dataset.breakpoint = layout === 'drawer' ? 'desktop' : originalBreakpoint;
        if (navWasFocused && layout === 'drawer') summary?.focus({ preventScroll: true });
        if (drawerWasFocused && desktop && layout !== 'drawer') {
          nav.querySelector('a, summary')?.focus({ preventScroll: true });
        }
        previousLayout = layout;
      }

      // The original sticky header only recalculated at 990px. Its actual height
      // also changes when links need a second row or the font finishes loading.
      if (section?.offsetHeight) {
        document.documentElement.style.setProperty('--header-height', `${section.offsetHeight}px`);
      }
    }

    const resize = new ResizeObserver(schedule);
    [header, list, icons, logo].filter(Boolean).forEach((element) => resize.observe(element));
    const mutations = new MutationObserver(schedule);
    mutations.observe(list, { childList: true, subtree: true, characterData: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.fonts?.ready.then(schedule);
    document.fonts?.addEventListener('loadingdone', schedule);
    controllers.set(header, {
      disconnect() {
        resize.disconnect();
        mutations.disconnect();
        cancelAnimationFrame(frame);
        window.removeEventListener('resize', schedule);
        document.fonts?.removeEventListener('loadingdone', schedule);
      },
    });
    schedule();
  }

  const init = (root = document) => root.querySelectorAll('.pm-site-header').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.pm-site-header').forEach((header) => controllers.get(header)?.disconnect());
  });
})();
